import React from 'react';
import { Container, Form } from '../Payment/Payment.styles';
import PaymentHeader from '../Payment/components/PaymentHeader';
import { InputLabel } from './VehicleIdentifier.styles';
import { PlateOrChassiIdentifier } from './components/PlateOfChassiIdentifier';
import { AgriculturalMachineForm } from './components/AgriculturalMachine';
import { VesselForm } from './components/Vessel';
import { LocalStoreKeysEnum } from '../../models/enums/localstore-keys.enum';
import { useHistory } from 'react-router-dom';
import { InspectionTypeEnum } from '../../models/enums/inspection-type.enum';

const VehicleIdentifier = () => {
  const history = useHistory();

  const inspectionType = localStorage.getItem(LocalStoreKeysEnum.INSPECTION_TYPE_KEY);

  if (!inspectionType) history.push('inspection-type');

  const isVessel = inspectionType === InspectionTypeEnum.VESSEL;

  return (
    <Container>
      <PaymentHeader isVehicleIdentifier />
      <Form>
        {!isVessel && (
          <InputLabel>Identificação do veículo</InputLabel>
        )}
        {(inspectionType === InspectionTypeEnum.VEHICLE) && (
          <PlateOrChassiIdentifier />
        )}
        {(inspectionType === InspectionTypeEnum.AGRICULTURAL_MACHINE) && (
          <AgriculturalMachineForm />
        )}
        {isVessel && (
          <VesselForm />
        )}
      </Form>
    </Container>
  );
}

export default VehicleIdentifier;
